import { Component, OnInit, OnChanges, SimpleChanges, AfterContentInit, Input, ElementRef, ContentChild, ViewChild } from '@angular/core';
import { LanguageService } from './language.service';
import { Subscription } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'lem-lang',
  template: `<span [innerHTML]="_safeValue"></span><span #projectedContent style="display:none"><ng-content></ng-content></span>`,
  styleUrls: ['./language.component.scss']
})
export class LanguageComponent implements OnInit, OnChanges {
  @ViewChild('projectedContent', { static: true }) projectedContent: ElementRef;

  @Input("key")
  set key(n: string) {
    this._key = n;
  }
  public _defaultValue: string = "";
  public _key: string = "";
  public _value: string = "";
  public _safeValue: SafeHtml = "";
  private subscription: Subscription;

  @Input("params")
  set params(p: { [key: string]: string }) {
    this._params = p;
  }
  public _params: { [key: string]: string } = {};

  constructor(
    private langServ: LanguageService,
    private sanitizer: DomSanitizer, // Inject DomSanitizer
    private elementRef: ElementRef // Inject ElementRef
  ) { }

  public async ngAfterViewInit(): Promise<void> {
    // console.debug("LanguageComponent content initialized, projected content:", this.projectedContent.nativeElement.textContent);
    this._defaultValue = this.projectedContent.nativeElement.textContent.trim();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['params'] && !changes['params'].firstChange) {
      // Re-interpolate when params change
      if (this._value) {
        const rawValue = this._value.replace(/\[\[\s*([^\]]+?)\s*\]\]/g, (match, key) => {
          // Restore original placeholder for re-interpolation
          return `[[ ${key.trim()} ]]`;
        });
        this._value = this.interpolateParams(rawValue);
        this._safeValue = this.sanitizer.bypassSecurityTrustHtml(this._value);
      }
    }
  }

  public async ngOnInit(): Promise<void> {
    const rawValue = await this.langServ.get(this._key, this._defaultValue);
    this._value = rawValue; //await this.langServ.translate(rawValue, this._defaultValue);
    this._value = this.interpolateParams(this._value);
    this._safeValue = this.sanitizer.bypassSecurityTrustHtml(this._value); // Mark HTML as safe
    // console.log("LanguageComponent initialized with key:", rawValue, " -- ", this._key, "defaultValue:", this._defaultValue, "translated value:", this._value);

    // check for attribute matching language
    const langAttr = this.elementRef.nativeElement.getAttribute(this.langServ.currentLanguage);
    if (langAttr) {
      this._value = langAttr;
      this._value = this.interpolateParams(this._value);
      this._safeValue = this.sanitizer.bypassSecurityTrustHtml(this._value);
    }

    this.subscription = this.langServ.getLanguageChange().subscribe(async () => {
      const rawValue = await this.langServ.get(this._key, this._defaultValue);
      this._value = rawValue; //await this.langServ.translate(rawValue, this._defaultValue);
      this._value = this.interpolateParams(this._value);
      this._safeValue = this.sanitizer.bypassSecurityTrustHtml(this._value);

      const langAttr = this.elementRef.nativeElement.getAttribute(this.langServ.currentLanguage);
      if (langAttr) {
        this._value = langAttr;
        this._value = this.interpolateParams(this._value);
        this._safeValue = this.sanitizer.bypassSecurityTrustHtml(this._value);
      }
    });
  }

  private interpolateParams(value: string): string {
    if (!value) return '';
    if (!this._params || Object.keys(this._params).length === 0) {
      return value;
    }

    const replaceToken = (match: string, key: string) => {
      const trimmedKey = key.trim();
      if (this._params.hasOwnProperty(trimmedKey)) {
        const paramValue = this._params[trimmedKey];
        return paramValue !== null && paramValue !== undefined ? String(paramValue) : match;
      }
      return match;
    };

    // Support both {{ key }} and [[ key ]] placeholder syntaxes
    let result = value.replace(/\{\{\s*([^}]+?)\s*\}\}/g, replaceToken);
    result = result.replace(/\[\[\s*([^\]]+?)\s*\]\]/g, replaceToken);
    
    return result;
  }

  public ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
